const step_up = {
    verify_your_identity: 'ยืนยันตัวตนของคุณ',
    choose_method_description: 'เพื่อดำเนินการต่อ กรุณายืนยันว่าเป็นคุณด้วยวิธีใดวิธีหนึ่งต่อไปนี้',
    password: 'รหัสผ่าน',
    password_description: 'กรอกรหัสผ่านบัญชีของคุณ',
    enter_password_description: 'กรอกรหัสผ่านบัญชีของคุณเพื่อดำเนินการต่อ',
    enter_verification_code_description: 'กรอกรหัสยืนยันที่ส่งไปยัง {{identifier}}',
    subject_proof_description: 'เพื่อดำเนินการต่อ กรุณายืนยันว่าเป็นคุณผ่านบัญชีที่เชื่อมโยงกับบัญชีของคุณ จากนั้นคุณจะสามารถตั้งค่าวิธีการยืนยันได้',
    no_method_available: 'ไม่มีวิธีการยืนยันที่ใช้ได้',
    no_method_available_description: 'บัญชีของคุณไม่มีวิธีการที่สามารถทำการยืนยันนี้ให้เสร็จสิ้นได้ กรุณาติดต่อผู้ดูแลระบบเพื่อขอความช่วยเหลือ',
};
export default Object.freeze(step_up);
